import { render, staticRenderFns } from "./bmi-component.vue?vue&type=template&id=7fce15c0&scoped=true&"
import script from "./bmi-component.vue?vue&type=script&lang=js&"
export * from "./bmi-component.vue?vue&type=script&lang=js&"
import style0 from "./bmi-component.vue?vue&type=style&index=0&id=7fce15c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fce15c0",
  null
  
)

export default component.exports